import { CardContent } from '@svs/ui/react/card';
import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '../../../utils/entry.js';

type DrawCardPanelProps = PropsWithChildren<{
  ariaLabel?: string;
  ariaLive?: 'off' | 'polite' | 'assertive';
  className?: string;
}>;

/**
 * Panel container that is used for almost all content in the drawcard.
 *
 * @param root0 input object
 * @param root0.children the content inside the panel
 * @param root0.className classes to override the default styles.
 * @param root0.ariaLabel aria-label attribute for accessibility.
 * @param root0.ariaLive aria-live attribute for accessibility, default is "off".
 * @returns A panel container
 */
export default function DrawCardPanel({
  ariaLabel,
  ariaLive = 'off',
  children,
  className,
}: DrawCardPanelProps): ReactNode {
  return (
    <CardContent
      className={cn(
        'flex justify-between lg:justify-center lg:gap-1',
        'lg:flex-col',
        'p-[16px] lg:py-3 lg:pr-3 lg:pl-6',
        'border-stroke-low',
        'lg:border-b-0',
        className
      )}
      aria-label={ariaLabel}
      aria-live={ariaLive}
    >
      {children}
    </CardContent>
  );
}
